<template>
    <div class="code">
        <div class="input-group">
            <input type="code" class="form-control" style="padding: 21px;" v-model="url" @focus="$event.target.select()">
            <span class="input-group-btn">
<button class="btn btn-primary" type="button"  @click="doCopy"><span class="fa fa-copy" aria-hidden="true">
</span> Kopiraj kodo!</button>
</span>
        </div>

    </div>
</template>

<script>
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)

    export default {

        props: ['url'],
        data: function () {
            return {
                message: 'Copy These Text'
            }
        },
        methods: {
            doCopy: function () {
                var self = this;
                this.$copyText(this.url).then(function (e) {
                    alert("Uspešno ste kopirali kodo: " + self
                        .url);
                }, function (e) {
                    alert('Vaš brskalnik ne omogoča avtomatskega kopiranja. Prosimo označite kodo in kopirajte z desnim klikom na miški.')
                    console.log(e)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/helpers/CopyUrl.vue